import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { performLogout } from 'src/views/public/login/actions';
import { getUserToken } from 'src/common/helpers/StorageUtils';
import { parseJwt } from 'src/common/helpers';
import TextConstants from 'src/common/helpers/TextConstants';

const TheHeaderDropdown = () => {
  const dispatch = useDispatch();

  const [userName, setUserName] = useState('');

  useEffect(() => {
    // get the user's token
    const userToken = getUserToken();
    if (!userToken) return;
    // parse the token payload and get the username
    const parseToken = parseJwt(userToken);
    if (parseToken && parseToken['cognito:username']) {
      setUserName(parseToken['cognito:username']);
    }
  }, []);

  return (
    <CDropdown inNav className="c-header-nav-items mx-2" direction="down">
      <CDropdownToggle className="c-header-nav-link" caret={false}>
        {userName}
        <div className="c-avatar">
          <CIcon name="cil-user" size="xl" />
        </div>
      </CDropdownToggle>
      <CDropdownMenu className="py-0" placement="bottom-end">
        <CDropdownItem
          onClick={() => {
            dispatch(performLogout());
          }}
        >
          <CIcon name="cil-account-logout" className="mfe-2" title="Logout" />
          {TextConstants.Common.Logout}
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  );
};

export default TheHeaderDropdown;
